import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as samActions from './actions/sam-actions';
import AudioPlayer from './AudioPlayer';
import NowPlaying from './NowPlaying';

class RemixPlayer extends Component {

  componentDidMount(){
    this.props.samActions.getStreamUrl();
    this.props.samActions.checkIcecastMetadata();
    setInterval(() => {
      this.props.samActions.checkIcecastMetadata();
    }, 10000);
  }

  render(){
    return (
      <div className="Player Sam">
        <NowPlaying currentTrack={ this.props.currentTrack } />
        <AudioPlayer 
          stream_url={ this.props.currentTrack.stream_url } 
          remix={ this.props.player.remix } />
        <div className="clearfix"></div>
      </div>
    );
  }
}

function mapStateToProps(state, props){
  return {
    player: state.app.player.toJS(),
    currentTrack: state.app.currentTrack.toJS()
  }
}

function mapDispatchToProps(dispatch){
  return {
    samActions: bindActionCreators(samActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RemixPlayer);



// WEBPACK FOOTER //
// ./src/SamPlayer.js